import React, { useState } from 'react';
import clsx from 'clsx';
import { Hero } from '../../components/Hero';
import Button from '../../components/Button';
import { ApplySection } from '../../components/ApplySection';
import ConnectPeersImg from '../../assets/images/who-attends/connect-peers.png';
import './who-attends.css';

const categories = [
  {
    id: '',
    label: 'All Industries',
  },
  {
    id: 'automotive',
    label: 'Automotive',
  },
  {
    id: 'cybersecurity',
    label: 'Cybersecurity',
  },
  {
    id: 'energy',
    label: 'Energy',
  },
  {
    id: 'finance',
    label: 'Finance',
  },
  {
    id: 'government',
    label: 'Government',
  },
  {
    id: 'healthcare',
    label: 'Heahlthcare',
  },
  {
    id: 'manufacturing',
    label: 'Manufacturing',
  },
  {
    id: 'retail',
    label: 'Retail',
  },
  {
    id: 'telecom',
    label: 'Telecom',
  },
];

const companies = [
  {
    id: 0,
    label: '22nd Century Technologies',
    categories: [
      'automotive',
    ]
  },
  {
    id: 1,
    label: 'Abuja Electricity Distribution Company',
    categories: [
      'automotive',
    ]
  },
  {
    id: 2,
    label: 'Activision Publishing',
    categories: [
      'automotive',
    ]
  },
  {
    id: 3,
    label: 'Activision Publishing',
    categories: [
      'automotive',
    ]
  },
  {
    id: 4,
    label: '3M',
    categories: [
      'automotive',
    ]
  },
  {
    id: 5,
    label: '4 Shadow Analytix',
    categories: [
      'automotive',
    ]
  },
  {
    id: 6,
    label: 'A1 Hrvatska',
    categories: [
      'automotive',
    ]
  },
  {
    id: 6,
    label: 'Bank of China',
    categories: [
      'automotive',
    ]
  },
]

function WhoAttendsPage() {
  const [selectedCategory, setSelectedCategory] = useState({
    id: 'automotive',
    label: 'Automotive',
  });

  const filtered = selectedCategory.id ? companies.filter(item => item.categories.indexOf(selectedCategory.id) > -1) : companies;

  return (
    <div className="who-attends-page">
      <div className="who-attends-hero-wrapper">
        <Hero
          title="Who Attends"
          description="Make connections with people who can help push your AI initiatives forward. Our attendees are the reason Ai4 2023 is the industry’s most impactful AI event."
          buttonLabel="VIEW ALL COMPANIES"
        />
      </div>
      <div className="connect-peers-row">
        <div className="connect-peers">
          <h2>Connect 1:1 with<br/>Industry Peers </h2>
          <p className="body-16">
            Engage in productive 1:1 meetings with industry leaders at Ai4 2024. Discover networking opportunities in our app, cocktail hours, and scheduled breaks. Explore the impressive list of attendees registered for Ai4 2024.
          </p>
          <Button label="Connect now" />
        </div>
        <img src={ConnectPeersImg} alt="Connect peers" />
      </div>
      <div className="attending-companies">
        <h1 className="title">2024 Attending Companies</h1>
        <div className="row flex-wrap gap-10 justify-content-center">
          {
            categories.map(category => (
              <button
                key={category.id}
                className={clsx('category', category.id === selectedCategory.id && 'selected-category')}
                onClick={() => setSelectedCategory(category)}
              >
                {category.label}
              </button>
            ))
          }
        </div>
        <div className="row flex-wrap gap-10 justify-content-center companies">
          {
            filtered.map(company => (
              <div
                key={company.id}
                className="company"
              >
                {company.label}
              </div>
            ))
          }
        </div>
      </div>
      <ApplySection
        title="Unlock Exclusive Media Access"
        description="Get Behind the Scenes: Obtain a Media Pass to Ai4 2023 and Immerse Yourself in the Latest AI Breakthroughs, Expert Interviews, and Exclusive Coverage."
        buttonLabel="APPLY NOW"
      />
    </div>
  );
}

export default WhoAttendsPage;
